module.exports = __webpack_public_path__ + "static/football-league-mobile-4a083c090c8c3fe71f1c7b770686773f.jpg";